module.exports = __webpack_public_path__ + "img/banner.9797a92c.jpg";